import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const AdminGetStudentReports = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
           formData.append('user_id',payload.user_id);
           
           formData.append('report',payload.report);
       
           formData.append('course_url',payload.course_url);
       
           
           
           

           try{
               const res = await axios.post(ENDPOINT+"get-student-report.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default AdminGetStudentReports